import { EmployeesArray } from './EmployeeGetResponse';

export const EmptyEmployeeDeleteItem: EmployeesArray = {
  id: 0,
  employeeCode: '',
  name: '',
  password: '',
  isDairen: false,
  isAdmin: false,
};
